export default __webpack_public_path__ + "static/nric-front-f3c8d024dfd78804bfbba81f2f62187b.png";